/**
 * Objective List Helpers
 * Utility functions for managing learning objective lists
 */

export function addObjective(list: string[], setList: (list: string[]) => void) {
  setList([...list, '']);
}

export function updateObjective(
  index: number,
  value: string,
  list: string[],
  setList: (list: string[]) => void
) {
  const newList = [...list];
  newList[index] = value;
  setList(newList);
}

export function removeObjective(
  index: number,
  list: string[],
  setList: (list: string[]) => void
) {
  if (list.length > 1) {
    setList(list.filter((_, i) => i !== index));
  }
}
